import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './styles/FeedbackComponent.scss';
import i18n from '../utils/i18n';
import { openModal, resetModal } from '../actions/modalsActions';
import { modals } from '../utils/constants';
import './styles/FeedbackBubbleComponent.scss';
import feedback_icon from '../images/feedback_icon.svg';

const FeedbackBubbleComponent = ({ loggedIn, openModal }) => (
  <div
    className="feedback-bubble-component-container"
    onClick={ () => openModal(modals.SEND_FEEDBACK, { isLoggedIn: loggedIn }) }
  >
    <div className="feedback-bubble-text-wrapper">

      <span className="feedback-bubble-text">{i18n.t('feedback.BUBBLE_TEXT')}</span>
      <img src={ feedback_icon } alt={ i18n.t('feedback.BUBBLE_TEXT') } />
    </div>
  </div>
);

FeedbackBubbleComponent.propTypes = {
  loggedIn: PropTypes.bool
};

FeedbackBubbleComponent.defaultProps = {
  loggedIn: false
};

const mapStateToProps = state => ({
  loggedIn: state.auth.loggedIn
});

const mapDispatchToProps = dispatch => ({
  resetModal: () => dispatch(resetModal()),
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData))
});

export default connect(mapStateToProps, mapDispatchToProps)(
  FeedbackBubbleComponent
);



// WEBPACK FOOTER //
// ./src/components/FeedbackBubbleComponent.js